import type { ChaveSelo } from "@caint/engine";

export interface SealMedalProps {
  chave: ChaveSelo;
  roman?: string;
  size?: number;
}

/** Medalhão metálico do Selo QualiEMSERH. */
export function SealMedal({ chave, roman, size = 56 }: SealMedalProps) {
  const dev = chave === "dev" || chave === "pend";
  return (
    <div className={`seal-medal ${dev ? "seal-dev" : `seal-${chave}`}`} style={{ width: size, height: size }}>
      <span className="roman" style={{ fontSize: size * 0.42 }}>
        {roman ?? "0"}
      </span>
    </div>
  );
}

const PILL: Record<ChaveSelo, readonly [string, string, string]> = {
  ouro: ["var(--seal-ouro)", "OURO", "III"],
  prata: ["var(--seal-prata)", "PRATA", "II"],
  bronze: ["var(--seal-bronze)", "BRONZE", "I"],
  dev: ["var(--seal-dev)", "EM DESENV.", "0"],
  pend: ["var(--slate-400)", "PENDENTE", "—"],
};

export interface SealPillProps {
  chave: ChaveSelo;
}

/** Pílula compacta do selo (lista/cabeçalho). */
export function SealPill({ chave }: SealPillProps) {
  const [clr, lbl, roman] = PILL[chave];
  return (
    <span
      className="m-pill"
      style={{
        background: `color-mix(in srgb, ${clr} 15%, white)`,
        color: `color-mix(in srgb, ${clr} 78%, black)`,
      }}
    >
      <span
        style={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          background: clr,
          color: "#fff",
          display: "grid",
          placeItems: "center",
          fontFamily: "var(--font-mono)",
          fontSize: 8,
          fontWeight: 700,
        }}
      >
        {roman}
      </span>
      {lbl}
    </span>
  );
}
